export function formatNumber(value: number | null): string {
  if (value === null || value === undefined) return "--";
  return value.toLocaleString("fr-FR");
}

export function formatCurrency(value: number | null): string {
  if (value === null || value === undefined) return "--";
  return `${value.toLocaleString("fr-FR")}€`;
}

export function formatPercent(value: number | null): string {
  if (value === null || value === undefined) return "--";
  return `${value}%`;
}

export function getMarginColorClass(value: number | null): string {
  if (value === null) return "";
  if (value > 60) return "text-green-600 font-medium";
  if (value < 40) return "text-red-600 font-medium";
  return "";
}
